import React, {useEffect, useContext} from 'react';
import * as R from 'ramda';

import useAPI from '@/hooks/useAPI';
import {useProducerCtx} from '@/views/Layout/b2b/ProducerNavBar/state';
import {producerProfile} from '@/b2b/apis';
import {mapWithIndex} from '@/util';
import {useTranslation} from 'react-i18next';
import {SystemConfigCtx} from '@/contexts';

const InfoList = ({data}) => {
  const infoList = mapWithIndex((item, idx) => <li key={idx}>{item}</li>)(
    data || []
  );
  return (
    <ul
      style={{
        listStyleType: 'none',
        paddingInline: '0px',
        marginBlock: '0px',
      }}
    >
      {infoList}
    </ul>
  );
};

const ProfileInfo = ({profile, tr}) => (
  <table className='table table-bordered'>
    <tbody>
      <tr>
        <th className='table-active' width='30%'>
          {tr('name')}
        </th>
        <td>{profile.name}</td>
      </tr>
      <tr>
        <th className='table-active'>{tr('code')}</th>
        <td>{profile.code}</td>
      </tr>
      <tr>
        <th className='table-active'>{tr('op_email')}</th>
        <td>
          <InfoList data={profile.opEmail} />
        </td>
      </tr>
      <tr>
        <th className='table-active'>{tr('ac_email')}</th>
        <td>
          <InfoList data={profile.acEmail} />
        </td>
      </tr>
      <tr>
        <th className='table-active'>{tr('contract_addr')}</th>
        <td>
          <InfoList data={profile.contractAddress} />
        </td>
      </tr>
      <tr>
        <th className='table-active'>{tr('corr_addr')}</th>
        <td>
          <InfoList data={profile.corrAddress} />
        </td>
      </tr>
    </tbody>
  </table>
);

const MyProfile = () => {
  const [producer] = useProducerCtx();
  const {result, trigger} = useAPI(producerProfile, {pending: true});
  const profile = R.pathOr({}, ['data'], result);
  const {t: tr} = useTranslation('my_profile');
  const {siteName} = useContext(SystemConfigCtx);

  useEffect(
    () => {
      trigger(producer.producerId);
    },
    [producer]
  );

  return (
    <>
      <h3>{tr('title')}</h3>
      <p>{tr('subtitle', {siteName})}</p>
      <ProfileInfo profile={profile} tr={tr} />
      <p>{tr('remark', {siteName})}</p>
    </>
  );
};

export default MyProfile;
